import request from '@/lib/api'

const _BASE = "/api";
//=============================服务管理--服务上下架审核相关接口=========================
// 服务管理==下架操作
export function offService(id) {
  return request({
    url: `${_BASE}/tPmcServiceV3/offService/${id}`,
    method: 'get',
  })
}
// 服务管理==服务上下架审核列表（搜索以及分页）
export function getServeChecklist(params) {
  return request({
    url: `${_BASE}/tPmcService/audit_list`,
    method: 'get',
    params
  })
}
// 服务管理==服务上下架审核列表详情
export function serevCheckDetail(id) {
  return request({
    url: `${_BASE}/tPmcService/audit/${id}`,
    method: 'get'
  })
}
// 服务管理==服务上架审核列表==驳回
export function checkReturnUp(id, params) {
  return request({
    url: `${_BASE}/tPmcService/oReject/${id}`,
    method: 'get',
    params
  })
}
// 服务管理==服务上架审核列表==审核通过
export function checkPassUp(id) {
  return request({
    url: `${_BASE}/tPmcService/oPass/${id}`,
    method: 'get',
  })
}
// 服务管理==服务下架审核列表==驳回
export function checkReturnDown(id, params) {
  return request({
    url: `${_BASE}/tPmcService/dReject/${id}`,
    method: 'get',
    params
  })
}
// 服务管理==服务下架审核列表==审核通过
export function checkPassDown(id) {
  return request({
    url: `${_BASE}/tPmcService/dPass/${id}`,
    method: 'get',
  })
}
//=============================服务管理--服务管理相关接口=========================
// 服务管理==服务管理列表
export function serviceList(params) {
  return request({
    url: `${_BASE}/tPmcService/services`,
    method: 'get',
    params
  })
}
// 服务管理==服务管理详情
export function serviceDetail(id) {
  return request({
    url: `${_BASE}/tPmcService/admin/${id}`,
    method: 'get'
  })
}
//服务管理==服务管理详情==服务评论
export function serviceComment(id, params) {
  return request({
    url: `${_BASE}/tPmcService/service/comment/${id}`,
    method: 'get',
    params
  })
}






// 服务管理==我的服务==服务下架
export function downServe(params) {
  return request({
    url: `${_BASE}/tSocService/offShelf`,
    method: 'get',
    params
  })
}



// 企业详情
export function companyDetail(params) {
  return request({
    url: `${_BASE}/tSacService/company`,
    method: 'get',
    params
  })
}



//服务搜索关键词联想
export function getKeyWord(name) {
  return request({
    url: `${_BASE}/tSacService/keyword/${name}`,
    method: 'get',
  })
}

//获取版本详情
export function getVersion(id) {
  return request({
    url: `${_BASE}/tPmcServiceV3/service_version/${id}`,
    method: 'get',
  })
}
// 审核获取版本详情
export function getApplyVersion(id) {
  return request({
    url: `${_BASE}/tPmcServiceV3/apply_version/${id}`,
    method: 'get',
  })
}
export function serviceCommentNew(id, data) {
  return request({
    url: `${_BASE}/tPmcService/service/commentNew/${id}`,
    method: 'post',
    data
  })
}
// 获取服务各评价数量
export function getEachNum(id) {
  return request({
    url: `${_BASE}/tPmcService/service/comment/statistics/${id}`,
  })
}